import { EventBus } from 'vtils'

export const useBus = new EventBus<{
  select: (item: any) => any
}>()
